import { Component, OnInit, Input, forwardRef, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { 
    IonGrid, IonRow, IonCol, IonSpinner, ToastController
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import moment from 'moment';

import { MarvTagComponent, MarvButtonComponent, MarvInputComponent, MarvTextareaComponent } from '@marv/components';
import { MarvDateToStringPipe } from '@marv/pipes';
import { OrderService, OperationService, StoreService, MissionTypeService } from '@app/services';
import { OperationCard } from '@app/models';

@Component({
    selector: 'app-mission-additional-data',
    templateUrl: './additional-data.component.html',
    styleUrls: ['./additional-data.component.scss'],
    imports: [
        IonGrid, IonRow, IonCol, IonSpinner, TranslatePipe, ReactiveFormsModule, MarvDateToStringPipe,
        forwardRef(() => MarvTagComponent), forwardRef(() => MarvButtonComponent), forwardRef(() => MarvInputComponent), forwardRef(() => MarvTextareaComponent)
    ]
})
export class MissionAdditionalDataComponent  implements OnInit {

    @Input({alias : 'operationId', required : true}) operationId: number;
    @Input({alias : 'data', required : false}) data: any;    
    @Input({alias : 'canEdit', required : false}) canEdit: boolean = false;
    @Output() onChangeAdditionalsDatas = new EventEmitter<any>();

    isFetching: boolean = false;
    isFetchingSave: boolean = false;
    operation: OperationCard|null = null;
    lastModification: Date|null = null;

    additionalDataForm: FormGroup = new FormGroup({        
        v_cash_register_vr_coca: new FormControl(null, [Validators.min(0)]),       
        v_cash_register_dp_coca: new FormControl(null, [Validators.min(0)]),       
        v_cash_register_vr_monster: new FormControl(null, [Validators.min(0)]),       
        v_cash_register_dp_monster: new FormControl(null, [Validators.min(0)]),      
        v_snack_vr_coca: new FormControl(null, [Validators.min(0)]),      
        v_snack_dp_coca: new FormControl(null, [Validators.min(0)]),      
        v_snack_vr_monster: new FormControl(null, [Validators.min(0)]),      
        v_snack_dp_monster: new FormControl(null, [Validators.min(0)]),      
        v_entrance_vr_coca: new FormControl(null, [Validators.min(0)]),      
        v_entrance_dp_coca: new FormControl(null, [Validators.min(0)]),      
        v_entrance_vr_monster: new FormControl(null, [Validators.min(0)]),      
        v_entrance_dp_monster: new FormControl(null, [Validators.min(0)]),      
        v_shelf_vr_coca: new FormControl(null, [Validators.min(0)]),      
        v_shelf_dp_coca: new FormControl(null, [Validators.min(0)]),      
        v_shelf_vr_monster: new FormControl(null, [Validators.min(0)]),      
        v_shelf_dp_monster: new FormControl(null, [Validators.min(0)]),      
        v_frozen_vr_coca: new FormControl(null, [Validators.min(0)]),      
        v_frozen_dp_coca: new FormControl(null, [Validators.min(0)]),      
        v_frozen_vr_monster: new FormControl(null, [Validators.min(0)]),      
        v_frozen_dp_monster: new FormControl(null, [Validators.min(0)]),      
        v_others_vr_coca: new FormControl(null, [Validators.min(0)]),      
        v_others_dp_coca: new FormControl(null, [Validators.min(0)]),      
        v_others_vr_monster: new FormControl(null, [Validators.min(0)]),      
        v_others_dp_monster: new FormControl(null, [Validators.min(0)]),      
        comments: new FormControl(null)     
    });

    constructor(
        public translateService: TranslateService,
        private toastController: ToastController,
        private orderService: OrderService,
        private storeService: StoreService,
        public missionTypeService: MissionTypeService
    ) { }

    async ngOnInit() {
        this.operation = OperationService.Operations.find(o => o.id === this.operationId) || null;        
        if(!this.canEdit){
            this.additionalDataForm.disable();
        } 
    }
    
    async ngOnChanges(changes: SimpleChanges) {
        if(changes['data']){            
            await this.loadAdditionalsDatas();
        }
    }
    
    async loadAdditionalsDatas(){
        this.isFetching = true;
        this.lastModification = null;
        let values = {
            v_cash_register_vr_coca: null,       
            v_cash_register_dp_coca: null,       
            v_cash_register_vr_monster: null,       
            v_cash_register_dp_monster: null,      
            v_snack_vr_coca: null,      
            v_snack_dp_coca: null,      
            v_snack_vr_monster: null,      
            v_snack_dp_monster: null,      
            v_entrance_vr_coca: null,      
            v_entrance_dp_coca: null,      
            v_entrance_vr_monster: null,      
            v_entrance_dp_monster: null,      
            v_shelf_vr_coca: null,      
            v_shelf_dp_coca: null,      
            v_shelf_vr_monster: null,      
            v_shelf_dp_monster: null,      
            v_frozen_vr_coca: null,      
            v_frozen_dp_coca: null,      
            v_frozen_vr_monster: null,      
            v_frozen_dp_monster: null,      
            v_others_vr_coca: null,      
            v_others_dp_coca: null,      
            v_others_vr_monster: null,      
            v_others_dp_monster: null,      
            comments: null     
        };
        
        if(this.data !== null){
            values = {
                v_cash_register_vr_coca: (this.data.v_cash_register_vr_coca !== undefined ? this.data.v_cash_register_vr_coca : null),       
                v_cash_register_dp_coca: (this.data.v_cash_register_dp_coca !== undefined ? this.data.v_cash_register_dp_coca : null),       
                v_cash_register_vr_monster: (this.data.v_cash_register_vr_monster !== undefined ? this.data.v_cash_register_vr_monster : null),       
                v_cash_register_dp_monster: (this.data.v_cash_register_dp_monster !== undefined ? this.data.v_cash_register_dp_monster : null),       
                v_snack_vr_coca: (this.data.v_snack_vr_coca !== undefined ? this.data.v_snack_vr_coca : null),       
                v_snack_dp_coca: (this.data.v_snack_dp_coca !== undefined ? this.data.v_snack_dp_coca : null),       
                v_snack_vr_monster: (this.data.v_snack_vr_monster !== undefined ? this.data.v_snack_vr_monster : null),       
                v_snack_dp_monster: (this.data.v_snack_dp_monster !== undefined ? this.data.v_snack_dp_monster : null),       
                v_entrance_vr_coca: (this.data.v_entrance_vr_coca !== undefined ? this.data.v_entrance_vr_coca : null),       
                v_entrance_dp_coca: (this.data.v_entrance_dp_coca !== undefined ? this.data.v_entrance_dp_coca : null),       
                v_entrance_vr_monster: (this.data.v_entrance_vr_monster !== undefined ? this.data.v_entrance_vr_monster : null),       
                v_entrance_dp_monster: (this.data.v_entrance_dp_monster !== undefined ? this.data.v_entrance_dp_monster : null),       
                v_shelf_vr_coca: (this.data.v_shelf_vr_coca !== undefined ? this.data.v_shelf_vr_coca : null),       
                v_shelf_dp_coca: (this.data.v_shelf_dp_coca !== undefined ? this.data.v_shelf_dp_coca : null),       
                v_shelf_vr_monster: (this.data.v_shelf_vr_monster !== undefined ? this.data.v_shelf_vr_monster : null),       
                v_shelf_dp_monster: (this.data.v_shelf_dp_monster !== undefined ? this.data.v_shelf_dp_monster : null),       
                v_frozen_vr_coca: (this.data.v_frozen_vr_coca !== undefined ? this.data.v_frozen_vr_coca : null),       
                v_frozen_dp_coca: (this.data.v_frozen_dp_coca !== undefined ? this.data.v_frozen_dp_coca : null),       
                v_frozen_vr_monster: (this.data.v_frozen_vr_monster !== undefined ? this.data.v_frozen_vr_monster : null),       
                v_frozen_dp_monster: (this.data.v_frozen_dp_monster !== undefined ? this.data.v_frozen_dp_monster : null),       
                v_others_vr_coca: (this.data.v_others_vr_coca !== undefined ? this.data.v_others_vr_coca : null),       
                v_others_dp_coca: (this.data.v_others_dp_coca !== undefined ? this.data.v_others_dp_coca : null),       
                v_others_vr_monster: (this.data.v_others_vr_monster !== undefined ? this.data.v_others_vr_monster : null),       
                v_others_dp_monster: (this.data.v_others_dp_monster !== undefined ? this.data.v_others_dp_monster : null),       
                comments: (this.data.comments !== undefined ? this.data.comments : null)
            };
            if(this.data.last_modification){
                this.lastModification = moment.unix(this.data.last_modification).utc().toDate();
            }
        }
                
        this.additionalDataForm.setValue(values, {emitEvent: false});
        this.isFetching = false;
    }

    async saveAdditionalsDatas(){        
        this.isFetchingSave = true;
        if(this.additionalDataForm.valid){
            let data: any = {
                v_cash_register_vr_coca: this.additionalDataForm.value.v_cash_register_vr_coca,       
                v_cash_register_dp_coca: this.additionalDataForm.value.v_cash_register_dp_coca,       
                v_cash_register_vr_monster: this.additionalDataForm.value.v_cash_register_vr_monster,       
                v_cash_register_dp_monster: this.additionalDataForm.value.v_cash_register_dp_monster,      
                v_snack_vr_coca: this.additionalDataForm.value.v_snack_vr_coca,      
                v_snack_dp_coca: this.additionalDataForm.value.v_snack_dp_coca,      
                v_snack_vr_monster: this.additionalDataForm.value.v_snack_vr_monster,      
                v_snack_dp_monster: this.additionalDataForm.value.v_snack_dp_monster,      
                v_entrance_vr_coca: this.additionalDataForm.value.v_entrance_vr_coca,      
                v_entrance_dp_coca: this.additionalDataForm.value.v_entrance_dp_coca,      
                v_entrance_vr_monster: this.additionalDataForm.value.v_entrance_vr_monster,      
                v_entrance_dp_monster: this.additionalDataForm.value.v_entrance_dp_monster,      
                v_shelf_vr_coca: this.additionalDataForm.value.v_shelf_vr_coca,      
                v_shelf_dp_coca: this.additionalDataForm.value.v_shelf_dp_coca,      
                v_shelf_vr_monster: this.additionalDataForm.value.v_shelf_vr_monster,      
                v_shelf_dp_monster: this.additionalDataForm.value.v_shelf_dp_monster,      
                v_frozen_vr_coca: this.additionalDataForm.value.v_frozen_vr_coca,      
                v_frozen_dp_coca: this.additionalDataForm.value.v_frozen_dp_coca,      
                v_frozen_vr_monster: this.additionalDataForm.value.v_frozen_vr_monster,      
                v_frozen_dp_monster: this.additionalDataForm.value.v_frozen_dp_monster,      
                v_others_vr_coca: this.additionalDataForm.value.v_others_vr_coca,      
                v_others_dp_coca: this.additionalDataForm.value.v_others_dp_coca,      
                v_others_vr_monster: this.additionalDataForm.value.v_others_vr_monster,      
                v_others_dp_monster: this.additionalDataForm.value.v_others_dp_monster,      
                comments: this.additionalDataForm.value.comments,
                last_modification: moment().unix()    
            };
            
            this.onChangeAdditionalsDatas.emit(data);
              
        }
        else{
            for (var controlName in this.additionalDataForm.controls) {
                if(!this.additionalDataForm.controls[controlName].valid) {
                    this.additionalDataForm.controls[controlName].markAsTouched();
                }
            }
        }
        this.isFetchingSave = false;    
    }
    
    resetAdditionalsDatas(){
        this.additionalDataForm.reset();
    }
}
